import React, {useContext, useCallback} from 'react';
import {useLocation} from 'react-router-dom';
import SearchStore from 'js/store/SearchStore';
import UserProfile from './UserProfile/UserProfile';
import Notifications from 'js/components/Notifications/Notifications';
import { CommonContext } from 'js/context/CommonContext/CommonContext';
import SearchButton from 'js/containers/Pages/Search/SearchBlock/SearchButton/SearchButton';
import NavigationMenu from 'js/components/Common/Navigation/NavigationMenu/NavigationMenu';
import TranslateSelector from 'js/components/Common/Header/TranslateSelector/TranslateSelector';
import {observer} from 'mobx-react';

import classes from './Header.module.pcss';


const HeaderPostLogin = () => {
	const {showSearch} = SearchStore;
	const {pathname} = useLocation();
	const {currentUser} = useContext(CommonContext);

	const searchIconClickHandler = useCallback(() => {
		SearchStore.setShowSearch(!showSearch);
	}, [showSearch]);


	return (
		<>
			<NavigationMenu location={'MAIN_MENU'} isMobile={true} levels={2} />
			<div className={classes.HeaderUserWrapper}>
				{pathname !== '/homepage' && <SearchButton handler={searchIconClickHandler} />}
				<Notifications offsetTop={4} />
				<TranslateSelector />
				<UserProfile offsetTop={15} userData={currentUser} />
			</div>
		</>
	);
};

export default observer(HeaderPostLogin);
